import cleanedFilename from '~/util/cleanedFilename';

export default {
  CONTAINER: `${cleanedFilename(__filename)}-container`,
  CANCEL_BUTTON: `${cleanedFilename(__filename)}-cancel-button`,
  NEXT_BUTTON: `${cleanedFilename(__filename)}-next-button`,
  PREVIOUS_BUTTON: `${cleanedFilename(__filename)}-previous-button`,
  COMPLETE_BUTTON: `${cleanedFilename(__filename)}-next-button`,
};
